export default class RegionService {

  static handleRegion(regionId) {
    switch (regionId) {
      case 1: return "Moscow, Russia";
      case 2: return "Saint-Petersburg, Russia";
      case 3: return "Helsinki, Finland";
      case 4: return "Tallin, Estonia";
      case 5: return "Riga, Latvia";
      case 6: return "Warsaw, Poland";
      case 7: return "Kiyv, Ukraine";
      case 8: return "Minsk, Belarus";
      case 9: return "Vilnius, Lithuania";
      case 10: return "Paris, France";
      case 11: return "Amsterdam, Nederland";
      case 12: return "Oslo, Norway";
      case 13: return "Stockholm, Sweden";
      case 14: return "Сopenhagen, Denmark";
      case 15: return "Tbilisi, Georgia";
      case 16: return "London, UK";
      case 17: return "Dublin, Island";
      case 18: return "Berlin, Germany";
      case 19: return "Yerevan, Armenia";
      default: return "";
    }
  }

  static getFlagUrl(regionId) {
    const flags = {
      0: "ru.png", 
      1: "fi.png", 
      2: "ee.png", 
      3: "lv.png", 
      4: "pl.png", 
      5: "ua.png", 
      6: "by.png", 
      7: "lt.png", 
      8: "fr.png", 
      9: "nl.png", 
      10: "no.png", 
      11: "se.png", 
      12: "dk.png", 
      13: "ge.png", 
      14: "gb.png",
      15: "ie.png", 
      16: "de.png", 
      17: "am.png", 
    };
    return `/flags/${flags[regionId] || "default.png"}`;
  }
}